/**
 * Console-based observability provider for development environments.
 * 
 * This provider logs all events to the browser console with formatted output,
 * making it easy to debug and validate event tracking during development.
 */

import { ObservabilityProvider } from './types';

export class ConsoleObservabilityProvider implements ObservabilityProvider {
  trackEvent(eventName: string, attributes: Record<string, unknown>): void {
    try {
      console.log(
        `%c[Observability]%c ${eventName}`,
        'color: #00a8e8; font-weight: bold',
        'color: inherit',
        attributes
      );
    } catch (error) {
      console.error('[Observability] Failed to log event:', error);
    }
  }

  isAvailable(): boolean {
    return true;
  }
}

